import { Chip } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

/**
 * StatusPill — semantic-color Chip for a subject / assignment status.
 *
 * Status vocabulary is kept small so the palette stays scannable:
 *   active   → success  (green)
 *   pending  → warning  (amber)
 *   disabled → default  (grey)
 *   revoked  → default  (grey, subdued)
 *   expired  → error    (muted red)
 *
 * Extra statuses fall through to the default grey chip so a caller
 * can pass an ad-hoc string without breaking the layout.
 */
const STATUS_MAP = {
  active: { label: "Active", color: "success", icon: CheckCircleOutlineIcon },
  pending: { label: "Pending", color: "warning", icon: HourglassEmptyIcon },
  disabled: { label: "Disabled", color: "default", icon: BlockOutlinedIcon },
  revoked: {
    label: "Revoked",
    color: "default",
    icon: RemoveCircleOutlineIcon,
  },
  expired: { label: "Expired", color: "error", icon: ErrorOutlineIcon },
};

export default function StatusPill({ status, label, size = "small", sx }) {
  const key = String(status || "").toLowerCase();
  const spec = STATUS_MAP[key] || {
    label: label || status || "Unknown",
    color: "default",
    icon: null,
  };
  const Icon = spec.icon;
  return (
    <Chip
      label={label || spec.label}
      size={size}
      color={spec.color}
      variant="outlined"
      icon={Icon ? <Icon fontSize="small" /> : undefined}
      sx={sx}
    />
  );
}
